// import styles from "./index.module.css";
import React, { useState, useEffect, useCallback } from "react";
import styles from "./index.module.css";
import { TabContainer, Tab } from "shared/TabContainer";
import Modal from "shared/Modal";
import Button from "shared/Button";
import External from "./Tabs/External";
import GracePeriod from "./Tabs/GracePeriod";
import ModalForm from "./Tabs/External/ModalForm";

export const tabs = {
  external: "External",
  gracePeriod: "GracePeriod",
};

export default function LOAPlugins() {
  const [selectedTab] = useState("External");
  const [refresh, setRefresh] = useState(false);

  return (
    <>
      <TabContainer value={selectedTab} className={styles.colorTest}>
        <Tab title="External" value={tabs.external}>
          <External />
        </Tab>

        <Tab title="Grace Period" value={tabs.gracePeriod}>
          <GracePeriod />
        </Tab>
      </TabContainer>
    </>
  );
}
